import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft, Phone, Mail } from 'lucide-react';

const LOGO_HEADER = "https://customer-assets.emergentagent.com/job_yacht-reserve-pro/artifacts/t54ah8ex_logo%203%20BELLA%20BARCA.png";
const LOGO_FOOTER = "https://customer-assets.emergentagent.com/job_yacht-reserve-pro/artifacts/k3tg8tl5_2.png";

const CGV_CONTENT = {
  title: "Conditions Générales de Vente",
  subtitle: "CGV",
  sections: [
    {
      title: "Champ d'application",
      content: "Les présentes conditions générales de vente (CGV) régissent toutes les ventes de produits effectuées sur le site web de A BELLA BARCA. En passant commande sur notre site, vous acceptez sans réserve ces CGV."
    },
    {
      title: "Commandes",
      content: "Pour passer commande sur notre site, vous devez être majeur(e) et disposer de la capacité juridique nécessaire pour conclure un contrat. En passant commande, vous vous engagez à fournir des informations exactes et complètes."
    },
    {
      title: "1. Prix et Paiement",
      content: "Les prix des produits sont indiqués en euros, toutes taxes comprises. Les frais de livraison sont à la charge du client et sont indiqués lors du processus de commande. Le paiement s'effectue en ligne par carte bancaire ou tout autre moyen de paiement accepté sur notre site."
    },
    {
      title: "2. Livraison",
      content: "Nous nous engageons à effectuer les prestations après réception du paiement.\n\nLe tarif indiqué en fonction de la date sélectionnée comprend :\n- Le carburant qui permettra votre balade en mer à la 1/2 journée ou en journée complète\n- La mise à disposition de l'embarcation"
    },
    {
      title: "3. Droit de Rétractation",
      content: "Plus de 14 jours avant la location : vous êtes remboursés de 50% du montant total de la location.\n\nMoins de 14 jours avant la location : aucun remboursement possible.\n\nCas de force majeure : En cas de mauvaises conditions météorologiques ne permettant pas la sortie en mer, nous procéderons au remboursement de la location dans son intégralité.\n\nCas concret : un BMS (Bulletin Météo Spécial) indiqué par la capitainerie de Sant'Ambroggio indiquant l'interdiction de naviguer."
    },
    {
      title: "4. Garanties",
      content: "Rappel : Nous ne pouvons pas garantir la destination."
    },
    {
      title: "5. Responsabilité",
      content: "Notre responsabilité ne saurait être engagée en cas de dommages indirects ou imprévisibles résultant de l'utilisation de nos produits."
    },
    {
      title: "6. Propriété Intellectuelle",
      content: "Tous les contenus présents sur notre site (textes, images, vidéos, etc.) sont protégés par le droit d'auteur et ne peuvent être reproduits ou utilisés sans notre autorisation écrite préalable."
    },
    {
      title: "7. Modifications des CGV",
      content: "Nous nous réservons le droit de modifier ces CGV à tout moment, sans préavis. Les modifications apportées seront applicables à toutes les commandes passées après leur publication sur notre site."
    },
    {
      title: "8. Litiges et Droit Applicable",
      content: "En cas de litige, les parties s'efforceront de trouver une solution amiable. À défaut, les tribunaux compétents seront ceux du lieu de notre siège social. Ces CGV sont soumises au droit français.\n\nEn passant commande sur notre site, vous acceptez sans réserve ces conditions générales de vente."
    }
  ]
};

const PRIVACY_CONTENT = {
  title: "Politique de Confidentialité",
  subtitle: "Protection de vos données",
  sections: [
    {
      title: "Avertissement légal",
      content: "Chez A BELLA BARCA, nous accordons une importance capitale à la protection de vos données personnelles. Cette politique de confidentialité vise à vous informer sur la manière dont nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web."
    },
    {
      title: "Collecte et Utilisation des Informations",
      content: "Lorsque vous visitez notre site web, nous pouvons collecter certaines informations personnelles vous concernant, telles que votre nom, votre adresse e-mail et d'autres données similaires que vous choisissez de nous fournir volontairement. Nous utilisons ces informations dans le seul but de répondre à vos demandes, de vous fournir des services personnalisés et de vous tenir informé(e) de nos produits, promotions ou événements spéciaux, si vous avez consenti à recevoir de telles communications."
    },
    {
      title: "Protection de Vos Données",
      content: "Nous nous engageons à protéger vos données personnelles et à les traiter de manière confidentielle. Nous mettons en oeuvre des mesures de sécurité appropriées pour protéger vos informations contre tout accès non autorisé, toute divulgation, toute altération ou toute destruction non autorisée."
    },
    {
      title: "Partage des Informations",
      content: "Nous ne vendons, ne louons ni ne partageons vos informations personnelles avec des tiers sans votre consentement explicite, sauf si cela est nécessaire pour répondre à vos demandes, pour fournir nos services ou si nous y sommes contraints par la loi."
    },
    {
      title: "Cookies",
      content: "Notre site web utilise des cookies pour améliorer votre expérience utilisateur. Ces cookies sont de petits fichiers texte placés sur votre appareil pour collecter des informations standard de journal Internet et de comportement des visiteurs de manière anonyme. Vous pouvez modifier les paramètres de votre navigateur pour désactiver les cookies, mais veuillez noter que certaines fonctionnalités de notre site pourraient ne pas fonctionner correctement sans eux."
    },
    {
      title: "Modifications de la Politique de Confidentialité",
      content: "Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment, sans préavis. Les modifications apportées à cette politique seront publiées sur cette page, et la date de révision la plus récente sera indiquée en haut de la page. Nous vous encourageons à consulter régulièrement cette politique pour rester informé(e) de la manière dont nous protégeons vos informations."
    },
    {
      title: "Contactez-nous",
      content: "Si vous avez des questions ou des préoccupations concernant notre politique de confidentialité, ou si vous souhaitez exercer vos droits en matière de protection des données, veuillez nous contacter à l'adresse e-mail : contact@abellabarca.com"
    }
  ]
};

const LEGAL_CONTENT = {
  title: "Mentions Légales",
  subtitle: "Informations légales",
  sections: [
    {
      title: "Éditeur du site",
      content: "A BELLA BARCA\nActivité : Location de bateaux sans permis\nAdresse : Port de Sant'Ambroggio, 20260 Lumio, Corse\nTéléphone : 06 87 99 96 39\nEmail : contact@abellabarca.com\nSite web : www.abellabarca.com"
    },
    {
      title: "Directeur de la publication",
      content: "Le directeur de la publication est le représentant légal de A BELLA BARCA."
    },
    {
      title: "Hébergement",
      content: "Le site est hébergé par la société assurant l'hébergement web du site www.abellabarca.com."
    },
    {
      title: "Conception du site",
      content: "Conception et réalisation : WEBISULA\nSite web : www.webisula.com"
    },
    {
      title: "Propriété intellectuelle",
      content: "L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) est la propriété exclusive de A BELLA BARCA ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.\n\nToute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de A BELLA BARCA."
    },
    {
      title: "Données personnelles",
      content: "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.\n\nPour exercer ces droits, vous pouvez nous contacter à l'adresse : contact@abellabarca.com\n\nPour plus d'informations, consultez notre Politique de Confidentialité."
    },
    {
      title: "Cookies",
      content: "Le site www.abellabarca.com peut utiliser des cookies pour améliorer l'expérience de navigation. Vous pouvez à tout moment modifier les paramètres de votre navigateur pour désactiver les cookies."
    },
    {
      title: "Limitation de responsabilité",
      content: "A BELLA BARCA s'efforce de fournir des informations aussi précises que possible sur le site. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.\n\nA BELLA BARCA ne pourra être tenue responsable des dommages directs ou indirects causés au matériel de l'utilisateur lors de l'accès au site."
    },
    {
      title: "Droit applicable",
      content: "Tout litige en relation avec l'utilisation du site www.abellabarca.com est soumis au droit français. L'utilisateur reconnaît la compétence exclusive des tribunaux compétents."
    }
  ]
};

const PAGES = {
  '/cgv': CGV_CONTENT,
  '/politique-confidentialite': PRIVACY_CONTENT,
  '/mentions-legales': LEGAL_CONTENT
};

export default function LegalPage() {
  const location = useLocation();
  const page = PAGES[location.pathname] || CGV_CONTENT;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#dec5ae]/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src={LOGO_HEADER} alt="A Bella Barca" className="h-14" />
            </Link>
            <Link to="/" className="flex items-center gap-2 text-[#0a57a4] hover:text-[#099dbb] transition-colors text-sm">
              <ChevronLeft className="w-4 h-4" />
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-28 pb-12 bg-[#0a57a4]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-[#099dbb] text-xs tracking-[0.2em] uppercase mb-3 font-semibold">{page.subtitle}</p>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white" data-testid="legal-page-title">
              {page.title}
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-sm border border-[#dec5ae]/30 p-8 sm:p-12" data-testid="legal-content">
            {page.sections.map((section, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className={i > 0 ? "mt-8 pt-8 border-t border-[#dec5ae]/20" : ""}
              >
                <h2 className="font-heading text-xl sm:text-2xl text-[#0a57a4] mb-4">{section.title}</h2>
                <div className="text-[#858275] leading-relaxed text-sm sm:text-base whitespace-pre-line">
                  {section.content}
                </div>
              </motion.div>
            ))}

            <div className="mt-12 pt-8 border-t border-[#dec5ae]/20 text-center">
              <p className="text-sm text-[#858275]">Dernière mise à jour : Mars 2026</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/cgv" className={`px-4 py-2 rounded-sm border transition-colors ${location.pathname === '/cgv' ? 'bg-[#0a57a4] text-white border-[#0a57a4]' : 'border-[#dec5ae]/40 text-[#858275] hover:border-[#099dbb] hover:text-[#099dbb]'}`} data-testid="link-cgv">
              CGV
            </Link>
            <Link to="/politique-confidentialite" className={`px-4 py-2 rounded-sm border transition-colors ${location.pathname === '/politique-confidentialite' ? 'bg-[#0a57a4] text-white border-[#0a57a4]' : 'border-[#dec5ae]/40 text-[#858275] hover:border-[#099dbb] hover:text-[#099dbb]'}`} data-testid="link-privacy">
              Politique de Confidentialité
            </Link>
            <Link to="/mentions-legales" className={`px-4 py-2 rounded-sm border transition-colors ${location.pathname === '/mentions-legales' ? 'bg-[#0a57a4] text-white border-[#0a57a4]' : 'border-[#dec5ae]/40 text-[#858275] hover:border-[#099dbb] hover:text-[#099dbb]'}`} data-testid="link-legal">
              Mentions Légales
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0a57a4] text-white py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            <img src={LOGO_FOOTER} alt="A Bella Barca" className="h-12" />
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
              <a href="tel:+33687999639" className="text-white/70 hover:text-[#099dbb] transition-colors text-sm flex items-center gap-2">
                <Phone className="w-4 h-4" />
                06 87 99 96 39
              </a>
              <a href="mailto:contact@abellabarca.com" className="text-white/70 hover:text-[#099dbb] transition-colors text-sm flex items-center gap-2">
                <Mail className="w-4 h-4" />
                contact@abellabarca.com
              </a>
            </div>
            <div className="text-white/50 text-xs">
              © 2026 A BELLA BARCA | Conception © 2025 <a href="https://www.webisula.com/" target="_blank" rel="noopener noreferrer" className="text-[#099dbb] hover:text-white transition-colors">WEBISULA</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
